export enum PalletType {
    NEW = 'new',
    EXISTING = 'existing'
}
